import { RootEpic } from "../../../store/epics";
import { isActionOf } from "typesafe-actions";
import { from, filter, switchMap, map, withLatestFrom } from "rxjs";
import { initAction, pushRoute } from "./actions";
import qs from "querystring";
import { ROUTES } from "../../../history";
import { navigateTo } from "../../../history";

const initEpic: RootEpic = (action$, state$, { api }) =>
  action$.pipe(
    filter(isActionOf(initAction.request)),
    withLatestFrom(state$),
    switchMap(([action, s]) => {
      if(window.location.pathname === '/general/disclaimer') {
        return [];
      }
      if (!s.app.token) {
        return [initAction.failure({ message: "no token" }), pushRoute({route: process.env.REACT_APP_BUILD_TARGET === "contractor" ?   ROUTES.CONTRACTOR_AUTH : ROUTES.ADMIN_AUTH})];
      }
      api.setToken(s.app.token as string);

      if (process.env.REACT_APP_BUILD_TARGET === "contractor") {
        return from(api.meContractor()).pipe(
          map((res) => {
            if (res.code === 200) {
              return initAction.success(res.data!.data as any);
            }
            return initAction.failure(
              res.code === -1
                ? { message: "Network failed" }
                : { message: res.errorData?.message || res.error }
            );
          })
        );
      }

      return from(api.me()).pipe(
        map((res) => {
          if (res.code === 200) {
            return initAction.success(res.data!.data);
          }
          return initAction.failure(
            res.code === -1
              ? { message: "Network failed" }
              : { message: res.errorData?.message || res.error }
          );
        })
      );
    })
  );

const initSuccessEpic: RootEpic = (action$) =>
  action$.pipe(
    filter(isActionOf(initAction.success)),
    switchMap(() => {
      console.log("here");
      const route = window.location.pathname;

      return [
        pushRoute({
          route: (route === "/auth"
            ? ROUTES.ADMIN_DASHBOARD
            : route === ROUTES.CONTRACTOR_AUTH
            ? ROUTES.CONTRACTOR_DASHBOARD
            : route) as ROUTES,
        }),
      ];
    })
  );
const navigateEpic: RootEpic = (actions$) =>
  actions$.pipe(
    filter(isActionOf(pushRoute)),
    switchMap(({ payload }) => {
      let extras = "";
      if (payload.extras) {
        extras += `?${qs.stringify(payload.extras)}`;
      }
      const route = payload.route + extras;
      console.log("lion" + route);
      navigateTo(route as ROUTES);
      return [];
    })
  );
const AppEpics = [initEpic, navigateEpic, initSuccessEpic];

export default AppEpics;
